import { database } from "firebase/app";

import { Message } from "./Instance";

const FOLDER_TEMPLATE = {
  updatedByDeviceId: "web",
  dateAdded: database.ServerValue.TIMESTAMP,
  dateRemoved: 0,
  isArchived: false,
  isStoresFoldersList: false,
  isWasOpened: false,
  lastOpenDate: database.ServerValue.TIMESTAMP,
};

export const createFolder = (title: string, path: string[]): Promise<void> => {
  const id = database().ref().child("books").push().key;

  if (!id) throw Error(Message.databaseId);

  const uid = path[0];
  const parentFolderId = path[path.length - 1];

  const folder = {
    ...FOLDER_TEMPLATE,
    title,
    addedBy: uid,
  };

  const updates = {
    [`/folders/${id}`]: folder,
    [`/folders/${parentFolderId}/folders/${id}`]: folder,
    [`/folders/${parentFolderId}/isStoresFoldersList`]: true,
    [`/libraries/${path.join("/folders/")}/folders/${id}`]: folder,
    [`/libraries/${path.join("/folders/")}/isStoresFoldersList`]: true,
  };

  return database().ref().update(updates);
};
